import { render, staticRenderFns } from "./CompareTrueIcon.vue?vue&type=template&id=26097da7"
import script from "./CompareTrueIcon.vue?vue&type=script&lang=js"
export * from "./CompareTrueIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports